import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  imageUrl: string;
  date: string;
  readCount?: number;
  hotIndex?: number;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categorySlug,
  imageUrl,
  date,
  readCount,
  hotIndex,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200 cursor-pointer"
    >
      <div className="aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
          title={title}
        />
      </div>
      <div className="p-4 md:p-5">
        <div className="flex items-center gap-2 mb-2.5 flex-wrap">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 font-medium hover:bg-primary-200 transition-colors whitespace-nowrap cursor-pointer"
          >
            {category}
          </Link>
          {hotIndex && (
            <span className="text-xs px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
              热度 {hotIndex}
            </span>
          )}
        </div>
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <span>{date}</span>
          {readCount && (
            <span className="flex items-center gap-1">
              <i className="ri-eye-line text-foreground-400"></i>
              {readCount > 10000 ? `${(readCount / 10000).toFixed(1)}万` : readCount}
            </span>
          )}
        </div>
      </div>
    </Link>
  );
}